/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2021-2024 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

// this is a react component that encapsulates the username and password form .
// It uses the authentactionservice to autheticate with tririga and then
// pushes the session token to the local sessionStorage.

import React from 'react';
import "../login-form/LoginForm.scss";
import {ChangePwdForm} from '../change-pwd-form/ChangePwdForm';
import {ForgotPwdEmailForm} from '../forgot-pwd-email-form/ForgotPwdEmailForm';
import { AuthenticationService } from '../service/AuthenticationService';

import { Form, TextInput, Link } from 'carbon-addons-iot-react';
import { ArrowRight32 } from '@carbon/icons-react';
import { Button, InlineNotification, ToastNotification } from "carbon-components-react";
import { AppMsg } from "../utils";
import CloudLogin from "./CloudLogin";

class LoginForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            isChangePassword: false,
            isForgotPassword: false,
            isPasswordChangeSuccess: false,
            errorMessage: '',
            errorMessageTitle: '',
            disableContinue: true,
            height: window.innerHeight,
        }
        this.textInputRef = null;
        this.loginObj = this._initLoginObj();
        this.passwordRules = {};
        this.customPasswordRules = [];
    }

    _initLoginObj() {
        let loginObj = {
            screenDPI: this._initScreenDPI(),
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            contentType: "/html/en",
            languageId: 1,
            ieFlag: 0,
        };
        //Get the remaining properties from query parameters.
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let isChangePassword = params.get('change-pwd');
        if (isChangePassword && isChangePassword === 'true') {
            loginObj.isChangePassword = true;
        } else {
            loginObj.isChangePassword = false;
        }
        let isAdmin = params.get('isAdmin');
        if (isAdmin && isAdmin === 'true') {
            loginObj.isAdmin = true;
        } else {
            loginObj.isAdmin = window.top.location.pathname.includes( "/html/en/default/admin" );
        }
        let isTririgaUX = params.get('isTririgaUX');
        if (isTririgaUX && isTririgaUX === 'true') {
            loginObj.isTririgaUX = true;
        } else {
            loginObj.isTririgaUX = false;
        }
        loginObj.ExtReqURL = params.get('ExtReqURL');
        loginObj.pageTitle = decodeURIComponent(params.get('pageTitle'));
        loginObj.state = params.get('state');

        return loginObj;
    }

    _initScreenDPI() {
        let screenDPI;
        try {
            screenDPI = window.screen.deviceXDPI;
            if(!screenDPI || screenDPI == 'null' || 
                    screenDPI == 'undefined' ||
                    screenDPI == 0) {
                screenDPI = 96;
            }
        } catch(ex) {
            screenDPI = 96;
        }
        return screenDPI;
    }

    _setUsername(name) {
        this.setState({
            username: name
        }, () => { this._validateInputFields() });
    }

    _setPassword(pwd) {
        this.setState({
            password: pwd
        }, () => { this._validateInputFields() });
    }

    _validateInputFields() {
        //if username and password fields are not empty then enable continue button
        if (this.state.username !== '' && this.state.password !== '' && this.state.errorMessage === '') {
            this.setState({
                disableContinue: false
            });
        } else {
            this.setState({
                disableContinue: true
            });
        }
    }

    _enableContinueButton() {
        this.setState({
            errorMessage: '',
            errorMessageTitle: ''
        }, () => { this._validateInputFields() });
    }

    async handleSubmit(event) {
        event.preventDefault();
        await this._handlePasswordRules(this.state.username); // Wait for password rules initialization
        AuthenticationService.login(this.state.username, this.state.password, this.loginObj).then(
            url => {
                if (this.loginObj.isTririgaUX) {
                    //For UX, url end point is already in place.
                    //Window location reload is same logic previous UX login page used.
                    // TODO: Implement a better solution. This is a temporary solution and work-around for story 95826
                    this._handleRoomPanelLogin(this.state.username, this.state.password);
                    window.top.location.reload();
                } else {
                    let tririgaUrl = url;
                    if (process.env.NODE_ENV === 'development') {
                        tririgaUrl = process.env.REACT_APP_DEV_HOST + "/.." + url;
                    }
                    window.top.location = tririgaUrl;
                }
            },
            error => {
                let isPasswordChangeRequired = error.includes("Password change is required.");
                this.setState({
                    errorMessage: !isPasswordChangeRequired ? this._handleErrorMessage(error): '',
                    errorMessageTitle: !isPasswordChangeRequired ? this._handleErrorMessageTitle(error): '',
                    isPasswordChangeSuccess: false,
                    isChangePassword: isPasswordChangeRequired,
                    disableContinue: true
                });
            }
        );
    }

    _handleErrorMessage(error) {
       return error === "Invalid username or password" ? 
                AppMsg.getMessage(AppMsg.APP_INVALID_USERNAME_PASSWORD): error;
    }

    _handleErrorMessageTitle(error) {
        return error === "Invalid username or password" ? 
                AppMsg.getMessage(AppMsg.APP_ERROR_INVALID_USERNAME_PASSWORD): AppMsg.getMessage(AppMsg.APP_ERROR);
    }

    _handleAutofill(e) {
        if (e.animationName === "onAutoFillStart") {
            console.log('Auto Fill Detected');
            //This will fail if only user name is filled by browser and empty password
            this._enableContinueButton();
        }
    }

    _handlePopstate() {
        this._handlePasswordVisibilityIconTabIndex();
        //Reset state back to login page on browser action.
        window.history.forward(); //Forward will disable forward button on login page.
        this.setState({
            isForgotPassword: false,
            isPasswordChangeSuccess: false,
            isChangePassword: false,
            username: '',
            password: ''
        });
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);

        //Check if this should redirect to change password.
        this._handleChangePasswordRedirect();

        //Detect browser back, forward, and refresh.
        window.addEventListener(
            "popstate",
            this._handlePopstate.bind(this)
        );
        this._handlePasswordVisibilityIconTabIndex();
    }
    
    componentWillUnmount(){
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('popstate', this._handlePopstate.bind(this));
    }

    _handlePasswordVisibilityIconTabIndex() {
        let pwdIcon = document.querySelector("button.bx--text-input--password__visibility__toggle");
        if (pwdIcon !== null) {
            //Index should be after password and before forgot password.
            pwdIcon.tabIndex = 3;
        }
    }


    async _handlePasswordRules(username) {
        if (Object.keys(this.passwordRules).length === 0) {
            try {
                const [passwordRules, customPasswordRules] = await Promise.all([
                    AuthenticationService.initPasswordRules(),
                    AuthenticationService.initCustomPasswordRules(username)
                ]);
                this.passwordRules = JSON.parse(passwordRules);
                this.customPasswordRules = customPasswordRules;
            } catch (error) {
                console.error('Error initializing password rules:', error);
            }
        }
    }

    _handleChangePasswordRedirect() {
        if (!this.loginObj.isChangePassword) return;
    
        this.setState({
            isChangePassword: true,
        }); 
    }
    
    handleResize = () => {
       this.setState({height: window.innerHeight});
    };

    redirectToLogin = () => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("change-pwd")) {
            let location = window.location.href.split("?")[0];
            let loginUrl = location.replace("/app/tririga-login", "/index.html");

            if (window.top != window.self) {
                window.top.history.pushState({ isPasswordChangeSuccess: true}, "", loginUrl);
            } else {
                window.history.pushState({ isPasswordChangeSuccess: true}, "", loginUrl);
            }
        }
    }

    showPwdSuccessfulLoginForm = () => {
        this._resetUserStateFromPasswordChange();
        this.redirectToLogin();
    };

    _resetUserStateFromPasswordChange = () => {
        this.setState({
            username: '',
            password: '',
            isChangePassword: false,
            errorMessage: '',
            errorMessageTitle: '',
            disableContinue: true,
            isPasswordChangeSuccess: true
        });
    }

    resetUserStateFromForgotPwdBackToLogin = () => {
        this.setState({
            username: '',
            password: '',
            isChangePassword: false,
            errorMessage: '',
            errorMessageTitle: '',
            disableContinue: true,
            isPasswordChangeSuccess: false,
            isForgotPassword: false
        });
    }

    handleInvalidUserOrPwdForMainLogin(username, password) {
        this.setState({
            username: username,
            password: password,
            isChangePassword: false,
            errorMessage: AppMsg.getMessage(AppMsg.APP_INVALID_USERNAME_PASSWORD),
            errorMessageTitle: AppMsg.getMessage(AppMsg.APP_ERROR_INVALID_USERNAME_PASSWORD),
            disableContinue: true,
        });
    }

    _getPasswordLabelWithForgotPwdLink() {
        return (
            <div style={{display:"flex", justifyContent: "space-between"}}>
                <div>{AppMsg.getMessage(AppMsg.APP_PASSWORD)}</div>
                <div>
                    <Link 
                        style={{fontStyle: "normal", fontWeight: "400", fontSize: "12px"}}
                        inline={true}
                        href="#"
                        onClick={(e) => {e.target.focus(); //Safari browser needs focus on link here to trigger onFocus event.
                                         this._handleForgotPasswordClick(e)}}
                        onMouseDown={() => {document.querySelector("#password").style.outline='none'}}
                        onFocus={() => {document.querySelector("#password").style.outline='none'}}    
                        onBlur={() => {document.querySelector("#password").style.outline='none'}}
                        tabIndex="5" 
                    >
                        {AppMsg.getMessage(AppMsg.APP_FORGOT_PASSWORD)}
                    </Link>
                </div>
        </div>
        );
    }

    _handleForgotPasswordClick(event) {
        //Push to history to support browser back from forgot password page.
        let historyObj = { title: window.title, url: window.location.href }; 
        window.history.pushState(historyObj, historyObj.title, historyObj.url);

        event.preventDefault();
        this.setState({
            isForgotPassword: true,
            isPasswordChangeSuccess: false
        });
    }

    renderChangePasswordForm()
    {
        return <ChangePwdForm
            username={ this.state.username }
            password={ this.state.password }
            showPwdSuccessfulLoginForm={ this.showPwdSuccessfulLoginForm.bind( this ) }
            handleInvalidUserOrPwdForMainLogin={ this.handleInvalidUserOrPwdForMainLogin.bind( this ) }
            passwordRules={ this.passwordRules }
            customPasswordRules={this.customPasswordRules}
        />;
    }

    renderPasswordChangeSuccess()
    {
        return (<div className="tri-inline-notification-div">
            <ToastNotification
                hideCloseButton={ false }
                iconDescription="close"
                kind="success"
                onCloseButtonClick={ () => this._enableContinueButton() }
                role="alert"
                statusIconDescription=""
                timeout={ 5000 }
                style={ { width: "100%" } }
                title={ AppMsg.getMessage( AppMsg.APP_PASSWORD_CHANGE_SUCCESSFUL ) } />
        </div>);
    }

    renderLoginMain()
    {
        const loginButtonProps =
        {
            kind: "primary",
            size: "field",
            renderIcon: ArrowRight32,
            onClick: ( e ) => this.handleSubmit( e ),
            type: "submit",
            disabled: this.state.disableContinue
        }

        return <div className="login-main-wrapper"  >
            <div className='login-wrapper'>
                { this.state.isPasswordChangeSuccess ? this.renderPasswordChangeSuccess() : '' }
                <div className="login-header">
                    <div>
                        <label>
                            { AppMsg.getMessage( AppMsg.APP_LOG_IN_TO ) + ' ' + this.loginObj.pageTitle }
                        </label>
                    </div>
                    <div>{ this.loginObj.isAdmin ?
                        <label>
                            { AppMsg.getMessage( AppMsg.APP_ADMIN_CONSOLE ) }
                        </label> : '' }
                    </div>
                </div>
                { this.state.errorMessage ? this.renderError() : '' }
                <hr className='horizontal-line' />
                <Form onSubmit={ this.handleSubmit.bind( this ) }>
                    <div>
                        <TextInput
                            labelText={ AppMsg.getMessage( AppMsg.APP_USERNAME ) }
                            id='username'
                            placeholder={ AppMsg.getMessage( AppMsg.APP_ENTER_USERNAME ) }
                            type="text" value={ this.state.username }
                            onChange={ ( e ) => this._setUsername( e.target.value ) }
                            onAnimationStart={ ( e ) => this._handleAutofill( e ) }
                            ref={ element => this.textInputRef = element } 
                            tabIndex="1"
                        />
                    </div>
                    <div>
                        <TextInput.PasswordInput
                            labelText={ this._getPasswordLabelWithForgotPwdLink() }
                            id='password'
                            placeholder={ AppMsg.getMessage( AppMsg.APP_ENTER_PASSWORD ) }
                            type="password"
                            onChange={ ( e ) => this._setPassword( e.target.value ) }
                            value={ this.state.password }
                            tabIndex="2"
                        />
                    </div>
                    <div>
                        <Button 
                            { ...loginButtonProps }
                            tabIndex={4}
                        >
                            { AppMsg.getMessage( AppMsg.APP_LOG_IN ) }
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    }

    renderError()
    {
        return <div className="tri-inline-notification-div">
            <InlineNotification
                hideCloseButton={ false }
                iconDescription="close"
                kind="error"
                notificationType="inline"
                onCloseButtonClick={ () => this._enableContinueButton() }
                role="alert"
                statusIconDescription=""
                subtitle={ this.state.errorMessage }
                title={ this.state.errorMessageTitle } />
        </div>;
    }

    render() 
    {
        const cloudLoginProps = {
            isAdmin: this.loginObj.isAdmin,
            onError: ( err ) => this.setState( { errorMessage: err } )
        }

        return <div style={ { height: this.state.height } }>
            { this.state.isChangePassword ?
                    this.renderChangePasswordForm()
                : this.state.isForgotPassword ?
                        <ForgotPwdEmailForm
                            resetUserStateFromForgotPwdBackToLogin={ this.resetUserStateFromForgotPwdBackToLogin.bind( this ) }
                        />
                    :
                        this.renderLoginMain()
            }
            <CloudLogin { ...cloudLoginProps } />
        </div>
    }

    _handleRoomPanelLogin(username, password) {
        const roomPanelUrl = window.top.location.pathname.includes('p/web/roomPanel');
        if (roomPanelUrl) {
            const login = btoa(`${username}+${password}+tririgaRoomPanel`);
            sessionStorage.setItem("triRoomPanelLogin", login);
        }
    }
}

export default LoginForm;